import FontBody1 from "../../../../components/fonts/font-body1/font-body1";
import FontHeading2 from "../../../../components/fonts/font-heading2/font-heading2";
import { FONT_COLOR, FONT_VARIANT } from "../../../../components/fonts/font-props";
import { BUTTON_VARIANTS } from "../../../../components/inputs/button-variants";
import { Button } from "../../../../components/inputs/button/button";
import Card from "../../../../components/layouts/card/card";
import dashboardStore from "../../../home/stores/dashboard-store";
import './setup-now-card.scss';

interface ISetupNowCardProps {
    onSetUpClicked: () => void
}

const SetupNowCard: React.FC<ISetupNowCardProps> = ({onSetUpClicked}) => {
    return (
        <Card>
            <div className={'set-up-now-card'}> 
                <div className={'set-up-now-card-content'}>
                    <FontHeading2 variant={FONT_VARIANT.BOLD} color={FONT_COLOR.PRIMARY2}>Ready to try it?</FontHeading2>
                    <FontBody1>
                        If you have any questions or need support,{' '}
                        <span className={'set-up-now-card-open-chat'} onClick={() => dashboardStore.openChat()}>
                            <FontBody1 variant={FONT_VARIANT.UNDER_LINE} color={FONT_COLOR.ACCENT1}>
                                consult an expert.
                            </FontBody1>
                        </span>
                    </FontBody1>
                </div>
                <Button text="Set up now" variant={BUTTON_VARIANTS.PrimaryAccent} onClick={onSetUpClicked} />
            </div>
        </Card>
    );
};

export default SetupNowCard;